import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import axios from 'axios';
import {
  HOME_CREATE_STRIPE_ACCOUNT_LINK_BEGIN,
  HOME_CREATE_STRIPE_ACCOUNT_LINK_SUCCESS,
  HOME_CREATE_STRIPE_ACCOUNT_LINK_FAILURE,
  HOME_CREATE_STRIPE_ACCOUNT_LINK_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function createStripeAccountLink(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_CREATE_STRIPE_ACCOUNT_LINK_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/subscriptions/create-stripe-account-link`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_CREATE_STRIPE_ACCOUNT_LINK_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_CREATE_STRIPE_ACCOUNT_LINK_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateStripeAccountLinkError() {
  return {
    type: HOME_CREATE_STRIPE_ACCOUNT_LINK_DISMISS_ERROR,
  };
}

export function useCreateStripeAccountLink() {
  const dispatch = useDispatch();

  const { createStripeAccountLinkPending, createStripeAccountLinkError } =
    useSelector(
      (state) => ({
        createStripeAccountLinkPending:
          state.home.createStripeAccountLinkPending,
        createStripeAccountLinkError: state.home.createStripeAccountLinkError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createStripeAccountLink(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissCreateStripeAccountLinkError());
  }, [dispatch]);

  return {
    createStripeAccountLink: boundAction,
    createStripeAccountLinkPending,
    createStripeAccountLinkError,
    dismissCreateStripeAccountLinkError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_CREATE_STRIPE_ACCOUNT_LINK_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createStripeAccountLinkPending: true,
        createStripeAccountLinkError: null,
      };

    case HOME_CREATE_STRIPE_ACCOUNT_LINK_SUCCESS:
      // The request is success
      return {
        ...state,
        createStripeAccountLinkPending: false,
        createStripeAccountLinkError: null,
      };

    case HOME_CREATE_STRIPE_ACCOUNT_LINK_FAILURE:
      // The request is failed
      return {
        ...state,
        createStripeAccountLinkPending: false,
        createStripeAccountLinkError: action.data.error,
      };

    case HOME_CREATE_STRIPE_ACCOUNT_LINK_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createStripeAccountLinkError: null,
      };

    default:
      return state;
  }
}
